import type { BffApiClient } from "@/app/api-client"
import type { InferRequestType } from "hono"

export type QueryInput = InferRequestType<
  BffApiClient["api"]["nfts"][":id"]["offers"]["$get"]
>["param"]

export const getNftOffersQueryParams = (
  apiClient: BffApiClient,
  queryInput: QueryInput,
) => ({
  queryKey: ["nfts", "offers", queryInput],
  queryFn: async ({ pageParam }: { pageParam?: string }) => {
    const response = await apiClient.api.nfts[":id"].offers.$get({
      param: queryInput,
      query: { cursor: pageParam },
    })

    if (!response.ok) throw await response.json()

    return response.json()
  },
  initialPageParam: undefined,
  getNextPageParam: (lastPage: { cursor?: string }) => {
    return lastPage.cursor
  },
})

type QueryFn = ReturnType<typeof getNftOffersQueryParams>["queryFn"]

export type QueryResponse = Awaited<ReturnType<QueryFn>>
